export const environment = {
  production: false,
  baseUrl: 'https://api.scheduler.qa.transflo.com/SchedulerAPI',
  agendaDaysToShow: 10
};
